////////LIBRARY/////////
import login from './login'
import languages from './languages'
import usersManager from './usersManager'
import errorManager from './errorManager'
import globalLoading from './globalLoading'
import modals from './modals'
import rolesManager from './rolesManager'
import tagsManager from './tagsManager'
import toastSuccess from './toastSuccess'
import myAccount from './account'
import kioskPerimeter from './kioskPerimeter'
import datePicker from './datePicker'
import recapStock from './recapStock'
import salesHistoryManager from './salesHistoryManager'
import scheduledPricesManager from './scheduledPricesManager'
import scheduledPromoManager from './scheduledPromoManager'
import pricesManagerByArticle from './pricesManagerByArticle'
import consignation from './consignation'
import kioskPricesManager from './kioskPricesManager'
import logExtranet from './logExtranet'
import logKiosk from './logKiosk'
import logSynchro from './logSynchro'
import logUsers from './logUsers'
import rgpd from './rgpd'
import campaignPrice from './campaignPrice'
import campaignPromo from './campaignPromo'
import telecollectManager from './telecollectManager'
import salesHistoryByCodes from './salesHistoryByCodes'
import salesByArticleHistoryManager from './salesByArticleHistoryManager'
import distributionGroupRepository from './distributionGroupRepository'
import articleManager from './articleManager'
import addItemCatalog from './addItemCatalog'
import companiesManager from './companiesManager'
import translationsManager from './translationsManager'
import exportDatas from './exportDatas'
import userPreferences from './userPreferences'
import notifications from './notifications'
import articleLifeManager from './articleLifeManager'
import headerCarousel from './headerCarousel'
import initKioskManager from './initKioskManager'
import initKioskCreationDefinition from './initKioskCreationDefinition'
import initKioskCreationBankDetails from './initKioskCreationBankDetails'
import initKioskCreationAddItems from './initKioskCreationAddItems'
import initKioskCreationAddPrices from './initKioskCreationAddPrices'
import initKioskCreationImplantation from './initKioskCreationImplantation'
import initKioskCreationSummary from './initKioskCreationSummary'
import marketing from './marketing'
import kioskProductionList from './kioskProductionList'
import kioskDiagnostic from './kioskDiagnostic'
import itemCatalog from './itemCatalog'
import itemCatalogDetail from './itemCatalogDetail'
import columns from './columns'
import kioskEditSetup from './kioskEditSetup'
import kioskRacksRequest from './kioskRacksRequest'
import kioskEditImplantation from './kioskEditImplantation'
import languagesManager from './languagesManager'
import table from './table'
import salesControl from './salesControl'

export const loginActionCreators = {
	...login,
}
export const languagesActionCreators = {
	...languages,
}
export const usersManagerActionCreators = {
	...usersManager,
}
export const errorManagerActionCreators = {
	...errorManager,
}
export const globalLoadingActionCreators = {
	...globalLoading,
}
export const modalsActionCreators = {
	...modals,
}
export const rolesManagerActionCreators = {
	...rolesManager,
}
export const tagsManagerActionCreators = {
	...tagsManager,
}
export const toastSuccessActionCreators = {
	...toastSuccess,
}
export const accountActionCreators = {
	...myAccount,
}
export const kioskPerimeterActionCreators = {
	...kioskPerimeter,
}
export const datePickerActionCreators = {
	...datePicker,
}
export const recapStockActionsCreators = {
	...recapStock,
}
export const consignationActionsCreators = {
	...consignation,
}

export const salesHistoryManagerActionCreators = {
	...salesHistoryManager,
}
export const scheduledPricesManagerActionCreators = {
	...scheduledPricesManager,
}
export const scheduledPromoManagerActionCreators = {
	...scheduledPromoManager,
}
export const pricesManagerByArticleActionCreators = {
	...pricesManagerByArticle,
}
export const kioskPricesManagerActionCreators = {
	...kioskPricesManager,
}
export const logExtranetActionCreators = {
	...logExtranet,
}
export const logKioskActionCreators = {
	...logKiosk,
}
export const logSynchroActionCreators = {
	...logSynchro,
}
export const logUsersActionCreators = {
	...logUsers,
}
export const rgpdActionCreators = {
	...rgpd,
}
export const campaignPriceActionCreators = {
	...campaignPrice,
}
export const campaignPromoActionCreators = {
	...campaignPromo,
}
export const telecollectManagerActionCreators = {
	...telecollectManager,
}
export const salesByArticleHistoryManagerActionCreators = {
	...salesByArticleHistoryManager,
}
export const salesHistoryByCodesActionCreators = {
	...salesHistoryByCodes,
}
export const distributionGroupRepositoryActionCreators = {
	...distributionGroupRepository,
}
export const articleManagerActionCreators = {
	...articleManager,
}
export const addItemCatalogActionCreators = {
	...addItemCatalog,
}
export const companiesManagerActionCreators = {
	...companiesManager,
}
export const translationsManagerActionCreators = {
	...translationsManager,
}
export const exportDatasActionCreators = {
	...exportDatas,
}
export const userPreferencesActionCreators = {
	...userPreferences,
}
export const notificationsActionCreators = {
	...notifications,
}
export const articleLifeManagerActionCreators = {
	...articleLifeManager,
}
export const headerCarouselActionCreators = {
	...headerCarousel,
}
export const initKioskManagerActionCreators = {
	...initKioskManager,
}
export const initKioskCreationDefinitionActionCreators = {
	...initKioskCreationDefinition,
}
export const initKioskCreationBankDetailsActionCreators = {
	...initKioskCreationBankDetails,
}
export const initKioskCreationAddItemsActionCreators = {
	...initKioskCreationAddItems,
}
export const initKioskCreationAddPricesActionCreators = {
	...initKioskCreationAddPrices,
}
export const initKioskCreationImplantationActionCreators = {
	...initKioskCreationImplantation,
}
export const initKioskCreationSummaryActionCreators = {
	...initKioskCreationSummary,
}
export const marketingActionCreators = {
	...marketing,
}
export const kioskProductionListActionCreators = {
	...kioskProductionList,
}
export const kioskDiagnosticActionCreators = {
	...kioskDiagnostic,
}
export const itemCatalogDetailActionCreators = {
	...itemCatalogDetail,
}
export const itemCatalogActionCreators = {
	...itemCatalog,
}
export const columnsActionCreators = {
	...columns,
}
export const kioskEditSetupActionCreators = {
	...kioskEditSetup,
}
export const kioskRacksRequestActionCreators = {
	...kioskRacksRequest,
}
export const kioskEditImplantationActionCreators = {
	...kioskEditImplantation,
}
export const languagesManagerActionCreators = {
	...languagesManager,
}
export const tableActionCreators = {
	...table,
}
export const salesControlActionCreators = {
	...salesControl,
}
